import LogIcon from '@material-ui/icons/Timeline';
import LogsList from './logsList';
import LogsShow from './logsShow';

export default {
  list: LogsList,
  show: LogsShow,
  icon: LogIcon,
};
